module.exports = __webpack_public_path__ + "img/contactImage.2d14f15d.svg";